import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from '../auth/auth-context';
import { loadCatalog } from './controlPlaneApi';

const ControlPlaneContext = createContext(null);

function BootstrapSession({ actorId, children }) {
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ loading: !!actorId, error: null, enabled: null, catalog: null });
  useEffect(() => {
    if (!actorId) return undefined;
    let current = true;
    const controller = new AbortController();
    loadCatalog(controller.signal).then(data => {
      if (!current) return;
      if (data?.contractVersion !== 1 || typeof data.controlPlanePhase1Ui !== 'boolean' ||
          !Number.isSafeInteger(data.catalogRevision) || !Array.isArray(data.applications)) {
        throw new Error('Invalid bootstrap');
      }
      setState({ loading: false, error: null, enabled: data.controlPlanePhase1Ui, catalog: data });
    }).catch(() => {
      if (current) setState({ loading: false, error: 'Unable to load applications.', enabled: null, catalog: null });
    });
    return () => { current = false; controller.abort(); };
  }, [actorId, attempt]);

  const retry = () => {
    setState({ loading: !!actorId, error: null, enabled: null, catalog: null });
    setAttempt(value => value + 1);
  };
  return <ControlPlaneContext.Provider value={{ ...state, actorId, retry }}>{children}</ControlPlaneContext.Provider>;
}

export function ControlPlaneProvider({ children }) {
  const { user } = useAuth();
  const actorId = user?.id || null;
  // Reset on the first render of a new identity, before an effect could expose
  // the previous identity's bootstrap or cards.
  return <BootstrapSession key={actorId || 'signed-out'} actorId={actorId}>{children}</BootstrapSession>;
}

export function useControlPlane() {
  const context = useContext(ControlPlaneContext);
  if (!context) throw new Error('useControlPlane requires ControlPlaneProvider');
  return context;
}
